// extracted by mini-css-extract-plugin
export var card = "menu-loader-module--card--ec89f";
export var row = "menu-loader-module--row--e0886 menu-loader-module--shimmer--0ed09";
export var shimmer = "menu-loader-module--shimmer--0ed09";
export var title = "menu-loader-module--title--860a8 menu-loader-module--shimmer--0ed09";
export var wrapper = "menu-loader-module--wrapper--49986";